module.exports = __webpack_public_path__ + "static/media/icon_excel.df5d0958.png";